const getCursorPosition = (e, image) => {
    let x = 0;
    let y = 0;

    if (!image) return { x, y };

    const { pageX, pageY } = e || window.event;

    // get the x and y positions of the image
    const { left, top } = image.getBoundingClientRect();

    // calculate the cursor's x and y coordinates, relative to the image
    x = pageX - left;
    y = pageY - top;

    // consider any page scrolling
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;

    return { x, y };
};

export default getCursorPosition;
